import type { OrderStatus } from '@/types/enums'

/** Активные статусы воронки — маркеры на карте только для них (см. `useOrdersForMap`). */
export const MAP_ACTIVE_STATUSES: OrderStatus[] = [
  'SEARCH',
  'ASSIGNED',
  'DRIVING',
  'ARRIVED',
  'INSPECTION',
  'APPRAISAL',
  'BUYING',
  'DOCUMENT_PREPARATION',
  'PAYMENT_TRANSFER',
  'TRANSPORTATION',
]
